
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M22.997.592l.822.816-10.592 10.676 10.589 10.505-.816.822-10.797-10.71L1.408 23.41l-.816-.822 10.59-10.505L.588 1.408 1.41.592 12.203 11.47 22.997.592z"}})])
      }
    
      }
    